import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M874.738114,645.125705 L462.691378,645.125705 L810.918614,296.898469 L640.008058,126 L0,765.995971 L640.008058,1406.00403 L810.918614,1235.09347 L462.691378,886.866237 L874.738114,886.866237 C1317.72764,886.866237 1678.16277,1247.30137 1678.16277,1690.29089 L1678.16277,1793.39323 L1919.9033,1793.39323 L1919.9033,1690.29089 C1919.9033,1113.98147 1451.16841,645.125705 874.738114,645.125705",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconReplySolid = /*#__PURE__*/function (_Component) {
  _inherits(IconReplySolid, _Component);

  var _super = _createSuper(IconReplySolid);

  function IconReplySolid() {
    _classCallCheck(this, IconReplySolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconReplySolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconReply",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconReplySolid.displayName = "IconReplySolid";
  return IconReplySolid;
}(Component);

IconReplySolid.glyphName = 'reply';
IconReplySolid.variant = 'Solid';
IconReplySolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconReplySolid;
export { IconReplySolid };